// With this node.js functionality we collect all modules of the
// store. What the folder structure and filenaming! (the basic )

import camelCase from 'lodash/camelCase'

// Object to collect all modules
const modules = {}

// Get all the files (node-specific functionality!)
const requireModule = require.context(
  '.', // Search for files in the current directory
  true, // Search for files in sub directories
  // Exclude index.js and files with "actions", "getters", "mutations" in them
  // Also, include only files with .js appendix
  /^(?!.*(actions|getters|mutations|index)).*\.js$/
)

requireModule.keys().forEach(fileName => {
  // console.log('fileName =', fileName)

  // Ignore unit test files
  if (/\.unit\.js$/.test(fileName)) {
    return
  }

  // Remove the file extension and convert to camelCase
  modules[camelCase(fileName.split('/')[1].replace(/(\.\/|\.js)/g, ''))] = {
    namespaced: true,
    ...requireModule(fileName).default
  }
})

export default modules
